import {combineReducers} from 'redux';
import {
  GROUPS_GET,
  GROUPS_RECEIVE
} from '../actionTypes/groups';


export default combineReducers({
  data(state = [], action) {
    switch (action.type) {
      case GROUPS_RECEIVE:
        return action.groups;
      default:
        return state;
    }
  },
  loading(state = false, action) {
    switch (action.type) {
      case GROUPS_GET:
        return true;
      case GROUPS_RECEIVE:
        return false;
      default:
        return state;
    }
  },
  fetched(state = false, action) {
    switch (action.type) {
      case GROUPS_GET:
        return true;
      default:
        return state;
    }
  }
});


// WEBPACK FOOTER //
// ./src/reducers/groups.js